module.exports = __webpack_public_path__ + "img/ezgif.com-optimize_2.57bf4434.gif";